module.exports = __webpack_public_path__ + "img/cnh-frente.3bdaba8a.jpg";